var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from 'redux-saga/effects';
import { SEARCH_SHIPMENT_REQUEST, searchShipmentFailure, searchShipmentSuccess } from '@/redux/actions';
import APIIN from '@/utils/APIIN';
const searchShipments = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.get(`/cnvt/shipment/search/${action.payload.searchType}?value=${action.payload.value}`)
                .then(data => {
                resolve(data);
            })
                .catch(error => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* searchShipmentsWorker(action) {
    try {
        const data = yield call(searchShipments, action);
        yield put(searchShipmentSuccess(data));
    }
    catch (error) {
        yield put(searchShipmentFailure(error));
    }
}
export function* watchSearchShipmentData() {
    yield takeLatest(SEARCH_SHIPMENT_REQUEST, searchShipmentsWorker);
}
